
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "../environments/environment";
import { AuthService } from "./auth.service";
import { Router } from "@angular/router";
import { Rekbot } from "../models/rekbot.model";
import { RekbotSettings } from "../models/rekbot-settings.model";

@Injectable({
    providedIn: 'root'
})

export class EmailListService {

    public emailList: string[] = [
    ];

    constructor(
        //private http: HttpClient,
        //private authService: AuthService,
        //private router: Router
    ) {

        console.log("construct", this.emailList)
    }

    addEmail(email: string) {
        this.emailList.push(email);
    }

    removeEmail(email:string) {
        const itemIndex = this.emailList.indexOf(email);

        this.emailList = this.emailList.filter((item) => {
            return item !== email;
        });
    }

    getList() {
        return this.emailList;
    }

    getEmail() {
        return this.emailList.join(";")
    }

    clearList() {
        this.emailList = []
    }

}